import { Box, styled } from '@mui/material';

export const HeadlineNewsContainer = styled(Box)(({ theme }) => ({
  height: 'auto',
  width: '100%',

  '& > :last-child': {
    display: 'none',
  },

  [theme.breakpoints.up('lg')]: {
    '& > :last-child': {
      display: 'flex',
    },
    width: '70%',
    height: '392px',
    padding: 0,
    order: 4,
  },
}));
